import React from "react";
import {
  Container,
  Row, Col,
  Card,
  CardBody,
  Button, Form,
  FormInput, FormGroup
} from "shards-react";

const ChangePassword = () => (
  <Container className="main-content-container h-100 px-4 container-fluid">
    <Row className="h-100 no-gutters">
      <Col className="auth-form mx-auto my-auto col-md-5 col-lg-4">
        <Card>
          <CardBody style={{ overflow: 'hidden',  boxShadow: 'inset 0 4px 0 0 #007bff', borderRadius: '.625rem' }}>
            <img className="auth-form__logo d-table mx-auto mb-3" src={require("../images/logo_login.png")}     alt="Galeno"  />
            <h5 className="auth-form__title text-center mb-4">Cambiar Contraseña</h5>
            <Form>
              <FormGroup>
                <label htmlFor="#password">Contraseña Actual</label>
                <FormInput type="password" id="#password" placeholder="Contraseña Actual" />
              </FormGroup>
              <FormGroup>
                <label htmlFor="#password">Nueva Contraseña</label>
                <FormInput type="password" id="#password" placeholder="Nueva Contraseña" />
              </FormGroup>
              <FormGroup>
                <label htmlFor="#password">Repetir Contraseña</label>
                <FormInput type="password" id="#password" placeholder="Repetir Contraseña" />
              </FormGroup>
              <Button className="d-table mx-auto btn-accent btn-pill">Cambiar Contraseña</Button>
            </Form>
          </CardBody>
        </Card>        
      </Col>
    </Row>
  </Container>
);

export default ChangePassword;
